enum ListSortFieldEnum {
    CreatedTime = 'CREATED_TIME',
}

export default ListSortFieldEnum;
